import { generateKeys } from '../utils';
export const alternativeCurrencies = generateKeys({
    NGN_alt: {
        value: 'NGN_alt',
        label: 'NGN Parallel',
    },
});
